import { PieceFragment } from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import ButtonLink from '@/ui/components/shared/ButtonLink';
import { RichTextRenderer } from '@/ui/components/tileRenderers/RichTextRenderer';
import { extractComponentFromChunk } from '@/ui/utils/tiles';
import React from 'react';
import { buildTrackingId } from '@/utils/tracking-helper';

export default function HeaderTextComponent({
  components,
  setIsOpen,
  trackingPrefix,
}: Readonly<{
  components: PieceFragment['components'];
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  trackingPrefix?: string;
}>) {
  const title = extractComponentFromChunk(components, 'title', 'SingleLineContent')?.text;
  const description = extractComponentFromChunk(components, 'description', 'RichTextContent');
  const cta = extractComponentFromChunk(components, 'cta', 'PieceContent');

  const ctaTrackingPrefix = buildTrackingId(trackingPrefix, title) ?? trackingPrefix;

  return (
    <div>
      <h3 className="text-2xl font-bold">
        {title}
        <span className="text-primary-100">.</span>
      </h3>
      <RichTextRenderer blocks={description} className="mt-1 text-xl" />
      <ButtonLink
        onClick={() => setIsOpen(false)}
        ctaComponent={cta as PieceFragment}
        className="mt-4 w-fit"
        trackingPrefix={ctaTrackingPrefix}
      />
    </div>
  );
}
